import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, Typography, Box, Button } from '@mui/material';
function AllTeachers({data}) {

  const [teacher,setTeacher]=useState(data.teachers)
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 3, p: 3 }}>
      {teacher.map((teacher) => (
        <Card key={teacher._id} sx={{ width: 300 }}>
          <CardContent>
            <Typography variant="h5" component="div">
              {teacher.firstName} {teacher.lastName}
            </Typography>
            <Typography sx={{ mb: 1.5 }} color="text.secondary">
              {teacher.subject}
            </Typography>
            <Typography variant="body2">
              <strong>Email:</strong> {teacher.email}
            </Typography>
            <Typography variant="body2">
              <strong>Phone:</strong> {teacher.phone}
            </Typography>
            <Typography variant="body2">
              <strong>Monthly Salary:</strong> ₹{teacher.salary}
            </Typography>
            <Typography variant="body2">
              <strong>Hire Date:</strong> {new Date(teacher.hireDate).toLocaleDateString()}
            </Typography>
            <Typography variant="body2">
              <strong>Teacher ID:</strong> {teacher._id}
            </Typography>
          </CardContent>
          <Box sx={{ textAlign: 'center', pb: 2 }}>
            <Button variant="contained" component={Link} to={`/teachers/${teacher._id}`} disabled>
              View Details
            </Button>
          </Box>
        </Card>
      ))}
    </Box>
  );
}

export default AllTeachers;
